<script setup lang="ts">
import CmsImage from '~/layers/cms/app/components/cms/CmsImage.vue'
import CmsText from '~/layers/cms/app/components/cms/CmsText.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Teksty/SliderBottom'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <CmsCustomComponentList
      :id="component_values?.id?.value"
      v-slot="{ component_values: ComponentValues }"
      :cms-data-path="[...props.cmsDataPath, 'component_data', 'list']"
      :open-options="true"
      component-name="images_list"
      class="min-w-5 min-h-5 py-10 px-2xl mb-20 flex flex-col xl:flex-row justify-between gap-16 bg-background-2"
    >
      <div
        v-for="(item, index) in ComponentValues"
        :key="JSON.stringify(item)"
        class="flex flex-row gap-5 items-start flex-1"
      >
        <CmsImage
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'image']"
          class="w-16 h-12"
        />
        <div class="flex flex-col gap-3">
          <span class="text-H4 text-Tekst font-semibold">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'text_1']"
            />
          </span>
          <span class="text-Tekst text-Paragraph">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'text_2']"
            />
          </span>
        </div>
      </div>
    </CmsCustomComponentList>
  </CmsCustomComponent>
</template>
